import { render, staticRenderFns } from "./acabadoForm.vue?vue&type=template&id=eb3f56b6"
import script from "./acabadoForm.ts?vue&type=script&lang=js&external"
export * from "./acabadoForm.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb3f56b6')) {
      api.createRecord('eb3f56b6', component.options)
    } else {
      api.reload('eb3f56b6', component.options)
    }
    module.hot.accept("./acabadoForm.vue?vue&type=template&id=eb3f56b6", function () {
      api.rerender('eb3f56b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/acabadoForm.vue"
export default component.exports